/* eslint-disable compat/compat */
export const checkTouchEventsSupport = () =>
    Boolean((window.PointerEvent && window.navigator?.maxTouchPoints > 0) || window.TouchEvent || 'ontouchstart' in window);
/* eslint-enable compat/compat */
